/**
 * Created by Kristy on 30/6/2016.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AdminSchedulesGridController', AdminSchedulesGridController);

    AdminSchedulesGridController.$inject = ['$scope', '$state','$http', '$rootScope', '$location', '$filter','KendoFilter', 'ApplicationParameters'];

    function AdminSchedulesGridController ($scope, $state, $http, $rootScope, $location, $filter, KendoFilter, ApplicationParameters) {
        var vm = this;
        var apiMeSchedulesURL = '/api/me/schedules';
        ApplicationParameters.hasModule('Scheduling', true);
        vm.pageHeading = 'Ραντεβου';
        vm.eventTarget = 'all';

        function onChange(arg) {
            // Get selected cell
            var selected = this.select();
            // Get the row that the cell belongs to.
            var row = this.select().closest("tr");
            var cellIndex = selected[0].cellIndex;

            if((cellIndex === 0 || cellIndex === 1) &&
                this.dataItem(row).eventCustomerSector.sector.sectorType.sectorTypeCategory === 'hcu') {
                var customerId = this.dataItem(row).eventCustomerSector.customerSector.customer.id;
                $rootScope.$apply(function() {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = customerId;
                    $state.go('customerInfo', {id: customerId, stateFrom: 'adminSchedulesGrid'});
                });
            } else if (cellIndex === 7 || cellIndex === 8) {
                var userId = this.dataItem(row).employee.id;
                $rootScope.$apply(function() {
                    $rootScope.selectedUser = {};
                    $rootScope.selectedUser.id = userId;
                    // $location.path('/employees/search').search({id:userId});
                    $state.go('userInfo', {id: userId, stateFrom: 'adminSchedulesGrid'});
                });
            } else {
                //this.clearSelection(row); //this throws error
                this.saveChanges();
            }
        }

        vm.mainGridOptions = {
            dataSource: new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function(o) {
                        if (o.data.filter === undefined) {
                            o.data.filter = { filters: [] };
                        }

                        angular.forEach( o.data.filter.filters, function(item) {
                            if ( item.value instanceof Date) {
                                item.value = $filter('date')(item.value, 'yyyy-MM-ddTHH:mm:ss.000') + 'Z';
                            }
                        });

                        if (vm.eventTarget === 'customers'){
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector",
                                operator: "isnotnull",
                                value: "null"
                            });
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.sector",
                                operator: "isnotnull",
                                value: "null"
                            });
                        }

                        if (vm.eventTarget === 'sectors') {
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.customerSector",
                                operator: "isnull",
                                value: "null"
                            });
                            o.data.filter.filters.push({
                                field: "eventCustomerSector.sector",
                                operator: "isnotnull",
                                value: "null"
                            });
                        }

                        $http.get(apiMeSchedulesURL,
                            {params: o.data})
                            .success(function (response,status,headers) {
                                o.success(response);
                            })
                            .error(function (response) {
                                console.log(response);
                            });
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== 'read') {
                            return JSON.stringify(data.models);
                        } else {
                            if (options.data.filter != undefined) {
                                angular.forEach(options.data.filter.filters, function (item) {
                                    if (item.field === "eventSchedule.startedAt") {
                                        item.value = kendo.toString(kendo.parseDate(item.value), 'yyyy-MM-dd');
                                    }
                                });
                            }
                            return data;
                        }
                    }
                },
                schema: {
                    data: function (data) {
                        if(data.content != undefined) {
                            data.content.forEach(function(item){

                                if (item.eventCustomerSector === null) {
                                    item.eventCustomerSector = {
                                        customerSector: {
                                            customer: {
                                                last_name: "",
                                                first_name: ""
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        }
                                    };
                                } else {
                                    if (item.eventCustomerSector.customerSector == null) {
                                        item.eventCustomerSector.customerSector = {
                                            customer: {
                                                last_name: "",
                                                first_name: "",
                                                doctorSpecialty: {
                                                    name: ""
                                                }
                                            },
                                            sector: {
                                                address: "",
                                                city: {
                                                    name: ""
                                                }
                                            }
                                        };
                                    }
                                }

                                if (item.eventCustomerSector.sector == null) {
                                    item.eventCustomerSector.sector = {
                                        sectorType: {}
                                    };
                                }

                                if (item.eventCustomerSector.sector.sectorType == null) {
                                    item.eventCustomerSector.sector.sectorType = {
                                        name: ""
                                    };
                                }

                                if (item.employee === null) {
                                    item.employee = { account: { lastName: ""}};
                                }else {
                                    if (item.employee.account === null) {
                                        item.employee.account = { lastName: "" };
                                    }
                                }

                            });
                        }

                        return data.content;
                    },
                    total: function (data) {
                        return data.totalEntries;
                    },
                    model: {
                        id: "id",
                        fields: {
                            id: { editable: false, nullable: true },
                            'eventSchedule.startedAt': { type: 'date'}
                        }
                    }
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                pageSize: 100
            }),
            sortable: true,
            pageable: true,
            resizable: true,
            filterable: {
                mode: "row"
            },
            columns: [
                {
                    title: "Επαγγελματίας Υγείας",
                    columns: [
                        {field: "eventCustomerSector.customerSector.customer.lastName", title: "Επώνυμο Επαγγελματία Υγείας",attributes: {
                            class: "#= eventCustomerSector.sector.sectorType.sectorTypeCategory == 'hcu' ? 'link-cell link-cell-color' : 'link-cell link-cell-color'#"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.customerSector.customer.firstName", title: "Όνομα Επαγγελματία Υγείας",attributes: {
                            class: "#= eventCustomerSector.sector.sectorType.sectorTypeCategory == 'hcu' ? 'link-cell link-cell-color' : ''#"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "eventSchedule.startedAt", title: "Ημερομηνία Ραντεβού", template: "#= eventSchedule.startedAt ? kendo.toString(kendo.parseDate(eventSchedule.startedAt), 'dddd, dd/MM/yyyy HH:mm') : ''#",
                    filterable: {
                        cell: {
                            operator: "eqdate",
                            showOperators: false
                        }
                    },
                    width:210
                },
                {
                    title: "Μονάδα Υγείας",
                    columns: [
                        {field: "eventCustomerSector.sector.sectorType.name", title: "Τύπος",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        { field: "eventCustomerSector.sector.name", title: "Όνομα",
                            template: "<span>#: eventCustomerSector.sector.name # </span>",
                            filterable: {
                                cell: {
                                    operator: "like",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width:210
                        },
                        {field: "eventCustomerSector.sector.address", title: "Διεύθυνση",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "eventCustomerSector.sector.cityName", title: "Πόλη",
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            },
                            width:120
                        }
                    ]
                },
                {
                    title: "Ιατρικός Επισκέπτης",
                    columns: [
                        {field: "employee.account.firstName", title: "Όνομα Ιατρικού Επισκέπτη",attributes: {
                            class: "#= 'link-cell link-cell-color' #"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        },
                        {field: "employee.account.lastName", title: "Επώνυμο Ιατρικού Επισκέπτη",attributes: {
                            class: "#= 'link-cell link-cell-color' #"
                        },
                            filterable: {
                                cell: {
                                    operator: "startswith",
                                    template: function (args) {
                                        KendoFilter.getTemplate(args);
                                    },
                                    showOperators: false
                                }
                            }
                        }
                    ]
                },
                {field: "title", title: "Τίτλος",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                },
                {field: "eventSchedule.description", title: "Σημειώσεις Ραντεβού",
                    filterable: {
                        cell: {
                            operator: "like",
                            template: function (args) {
                                KendoFilter.getTemplate(args);
                            },
                            showOperators: false
                        }
                    }
                }
            ],
            editable: "inline",
            selectable: "cell",
            change: onChange,
            toolbar: [{ template: "<div class='right'><label>Σύνολο: {{vm.mainGridOptions.dataSource.total()}}</label></div>",
                overflow: "never" }]
        };

        vm.onEventTargetChange = function () {
            vm.mainGridOptions.dataSource.read();
        };
    }
})();
